// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__16tOo","calendarButtons":"ClockData_calendarButtons__oF2wo"};